export const TABLE_CONFIG = {
    relatedOrganismsTable: {
        headers: ['BioSample ID', 'Organism', 'Common Name', 'Sex', 'Organism Part', 'Tracking Status'],
        cellNames: ['accession', 'organism', 'commonName', 'sex', 'organismPart', 'trackingSystem']
    },
    relatedAnnotationTable: {
        headers: [
            'Study Accession', 'Sample Accession', 'Secondary Sample Accession', 'Analysis Accession',
            'Analysis Title', 'Analysis Type', 'Assembly Type', 'Center Name', 'First Public',
            'Last Updated', 'Study Title', 'Tax ID', 'Study Alias', 'Analysis Alias',
            'Generated files: Size', 'Generated files: MD5', 'Generated files: FTP', 'Generated files: Aspera',
            'Generated files: Galaxy', 'Submitted files: Size', 'Submitted files: MD5', 'Submitted files: FTP',
            'Submitted files: Aspera', 'Broker Name', 'Sample Alias', 'Sample Title'
        ],
        cellNames: [
            'study_accession', 'sample_accession', 'secondary_sample_accession', 'analysis_accession',
            'analysis_title', 'analysis_type', 'assembly_type', 'center_name', 'first_public',
            'last_updated', 'study_title', 'tax_id', 'study_alias', 'analysis_alias',
            'generated_bytes', 'generated_md5', 'generated_ftp', 'generated_aspera',
            'generated_galaxy', 'submitted_bytes', 'submitted_md5', 'submitted_ftp',
            'submitted_aspera', 'broker_name', 'sample_alias', 'sample_title'
        ]
    },
    annotationTable: {
        headers: [
            'Accession',
            'Annotation',
            'Proteins',
            'Transcripts',
            'Softmasked genome',
            'Other data',
            'View in browser'
        ],
        cellNames: [
            'accession',
            'annotation.GTF',
            'annotation.GFF3',
            'proteins.FASTA',
            'transcripts.FASTA',
            'softmasked_genome.FASTA',
            'other_data.ftp_dumps',
            'view_in_browser'
        ]
    },
    relatedAssembliesTable: {
        headers: [
            'Accession',
            'Assembly Name',
            'Description',
            'Version'
        ],
        cellNames: [
            'accession',
            'assembly_name',
            'description',
            'version'
        ]
    },
    relatedFilesTable: {
        headers: [
            'Study Accession',
            'Sample Accession',
            'Experiment Accession',
            'Run Accession',
            'Tax Id',
            'Scientific Name',
            'FASTQ FTP',
            'Submitted FTP',
            'SRA FTP',
            'Base Count',
            'Broker Name',
            'Center Name',
            'Cram Index Aspera',
            'Cram Index Galaxy',
            'Cram Index FTP',
            'Experiment Alias',
            'Experiment Title',
            'Fastq Aspera',
            'Fastq Bytes',
            'Fastq Galaxy',
            'Fastq MD5',
            'First Created',
            'First Public',
            'Instrument Platform',
            'Instrument Model',
            'Last Updated',
            'Library Layout',
            'Library Name',
            'Library Strategy',
            'Library Source',
            'Library Selection',
            'Library Construction Protocol',
            'Nominal Length',
            'Nominal Sdev',
            'Read Count',
            'Run Alias',
            'Sample Alias',
            'Sample Title',
            'Secondary Sample Accession',
            'Secondary Study Accession',
            'SRA Aspera',
            'SRA Bytes',
            'SRA Galaxy',
            'SRA MD5',
            'Study Alias',
            'Study Title',
            'Submission Accession',
            'Submitted Aspera',
            'Submitted Bytes',
            'Submitted Format',
            'Submitted Galaxy',
            'Submitted MD5'
        ],
        cellNames: [
            'study_accession',
            'sample_accession',
            'experiment_accession',
            'run_accession',
            'tax_id',
            'scientific_name',
            'fastq_ftp',
            'submitted_ftp',
            'sra_ftp',
            'base_count',
            'broker_name',
            'center_name',
            'cram_index_aspera',
            'cram_index_galaxy',
            'cram_index_ftp',
            'experiment_alias',
            'experiment_title',
            'fastq_aspera',
            'fastq_bytes',
            'fastq_galaxy',
            'fastq_md5',
            'first_created',
            'first_public',
            'instrument_platform',
            'instrument_model',
            'last_updated',
            'library_layout',
            'library_name',
            'library_strategy',
            'library_source',
            'library_selection',
            'library_construction_protocol',
            'nominal_length',
            'nominal_sdev',
            'read_count',
            'run_alias',
            'sample_alias',
            'sample_title',
            'secondary_sample_accession',
            'secondary_study_accession',
            'sra_aspera',
            'sra_bytes',
            'sra_galaxy',
            'sra_md5',
            'study_alias',
            'study_title',
            'submission_accession',
            'submitted_aspera',
            'submitted_bytes',
            'submitted_format',
            'submitted_galaxy',
            'submitted_md5'
        ]
    }
};
